import { useState } from "react";
import { Button } from "../../components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../components/ui/dialog"
import { Input } from "../../components/ui/input"

import { 
    PlusIcon,
    AddPaymentMethodPopUp
 } from "../../components";

 const GetSubscriptionsPopUp = ({ isOpen, onClose, plan }) => {
    const [selectedCard, setSelectedCard] = useState(null);
    const [isPaymentPopupOpen, setPaymentPopupOpen] = useState(false);

    const handleSelection = (card) => {
        setSelectedCard(prevCard => prevCard === card ? null : card);
    };

    return (
        <>
            {/* Main Subscription Popup */}
            <Dialog open={isOpen} onOpenChange={onClose} className="">
                <DialogContent className="p-4 sm:p-6 bg-gray-0  max-w-full sm:max-w-[588px] responsive-mobile flex flex-col sm:flex-col justify-between sm:justify-center rounded-t-xl" closeClassname="remove-boxshadow top-7 right-7" closeIconClassname="">
                    <div>
                        <DialogHeader>
                            <DialogTitle className="pb-5 text-base font-bold text-gray-800 font-redhat">
                                {plan.title} {plan.price}
                                <span className="pl-1 text-base font-normal text-gray-800 font-redhat">{plan.frequency}</span>
                            </DialogTitle>
                        </DialogHeader>

                        {/* Payment Options */}
                        <div className="flex flex-col">
                            <div className="flex items-center h-full gap-6 border-b border-gray-100 cursor-pointer max-h-74" onClick={() => handleSelection("mastercard")}>
                                <div>
                                    <Input 
                                        type="radio" 
                                        id="mastercard" 
                                        name="paymentMethod" 
                                        className="w-24 h-24" 
                                        checked={selectedCard === "mastercard"}
                                        readOnly
                                    />
                                </div>
                                <div className="flex items-center gap-6">
                                    <div>
                                        <img src="/media/images/Mastercard.png" alt="Mastercard" />
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-gray-800 font-redhat">**** **** **** 6789</p>
                                        <p className="text-sm font-normal text-gray-600 font-redhat">Expiration Date: 02/2028</p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center h-full gap-6 border-b border-gray-100 cursor-pointer max-h-74" onClick={() => handleSelection("visa")}>
                                <div>
                                    <Input 
                                        type="radio" 
                                        id="visa" 
                                        name="paymentMethod" 
                                        className="w-24 h-24" 
                                        checked={selectedCard === "visa"}
                                        readOnly
                                    />
                                </div>
                                <div className="flex items-center gap-6">
                                    <div>
                                        <img src="/media/images/visa.png" alt="Visa" />
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-gray-800 font-redhat">**** **** **** 7892</p>
                                        <p className="text-sm font-normal text-gray-600 font-redhat">Expiration Date: 02/2028</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Add Payment Method Button */}
                        <div className="flex justify-center pt-5">
                            <button 
                                onClick={() => {
                                    setPaymentPopupOpen(true);
                                    onClose(); // Close current popup
                                }}
                                className="flex text-sm font-medium leading-4 text-gold-300 font-redhat"
                            >
                                <PlusIcon className="text-gold-300 group-hover:text-gold-500" />
                                Add Payment Method
                            </button>
                        </div>
                    </div>

                    {/* Footer with Confirm Button */}
                    <div>
                        <div className="hidden sm:block w-[calc(100%+48px)] mx-[-24px] border-t border-gray-100"></div>
                        <DialogFooter className="flex !justify-between gap-4 pt-5">
                            <div className="w-full">
                                <Button 
                                    className={`${selectedCard ? "bg-gold-300" : "bg-gray-400"} hover:bg-gold-300 hover:text-gray-0 border-0 rounded-[34px] w-full text-gray-0 text-base font-semibold font-redhat`}
                                    type="submit"
                                    disabled={!selectedCard} 
                                >
                                    Get {plan.title} Package for {plan.price}
                                </Button>
                            </div>
                        </DialogFooter>
                    </div>
                </DialogContent>
            </Dialog>

            {/* Add Payment Popup */}
            <AddPaymentMethodPopUp isOpen={isPaymentPopupOpen} onClose={() => setPaymentPopupOpen(false)} />
        </>
    );
};

export default GetSubscriptionsPopUp;

